module.exports = __webpack_public_path__ + "d9bf433a04e72e780a039ed3ef8d7d44.svg";